<template>
  <div>
    <button @click="isShownDescriptionModal = true" :class="$style.button">
      <IconQuestion />
      自動アプローチについて
    </button>
    <AppModal
      :shown="isShownDescriptionModal"
      closeable
      @close="isShownDescriptionModal = false"
    >
      <div :class="$style.description">
        <p :class="$style.description__title">自動アプローチについて</p>
        <p :class="$style.description__body">
          自動アプローチ機能とは、毎日1日に1件のペースでおすすめのユーザーに自動でアプローチを送信する機能です。<br />
          <br />
          現状は、ご利用のプランナー様の中から無作為に抽出した一部のプランナー様に限り公開している、限定機能となっております。<br />
          設定の有効・無効やアプローチ文章の変更は本ページからいつでも編集可能です。<br />
          <br />
          なかなかアプローチを送る時間が取れない、どのユーザーにアプローチを送ればいいのか迷って基本料金分を消化できない、という方はぜひお試しください。<br />
          <br />
          【留意事項】<br />
          ・自動で送信されたアプローチも、通常のアプローチの送信と同様に現在ご契約いただいているプランのアプローチ件数としてカウントされますので、ご注意ください。<br />
          ・基本料金分の件数に達した時点で、その月は送信が止まります。上限を超えて送信されることはないため、設定を有効にしていることで従量課金が発生することはありません。<br />
          ・おすすめのユーザーがいない場合には、1日に1件送られない日もあります。<br />
          ・自動アプローチによりユーザーとのマッチングや返信が発生することがありますので、その際はチャットでのご対応をお願いいたします。<br />
          ・設定いただいたアプローチ文章によっては、自動送信先のユーザーの診断結果とマッチしないこともあります。<br />
          ・自動アプローチは、成果をお約束する機能ではありません。留意事項をご確認いただいたうえで、ご利用の検討をお願いいたします。<br />
          ・先行リリース段階の機能となっているため、予告なく変更・終了することがあります。予めご容赦ください。
        </p>
      </div>
    </AppModal>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import AppModal from '@/components/atoms/AppModal.vue'
import IconQuestion from '@/components/icons/IconQuestion.vue'

const isShownDescriptionModal = ref(false)
</script>

<style lang="scss" module>
.button {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: $color-text-and-object-accent-primary;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
}

.description {
  margin-bottom: 32px;
  font-size: 16px;
  padding: 24px;

  &__title {
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 24px;
  }

  &__body {
    color: $color-text-and-object-medium-emphasis;
    font-size: 16px;
  }
}
</style>
